import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../../store/store';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import QuestionnaireResultsWithScoringList from './QuestionnaireResultsWithScoringList';

loadDOMComponent({
	selector: 'react-questionnaire-results-with-scoring',
	callback: ({ container, context }: any) => {
		const questionnaireCode = container.getAttribute('data-questionnaire-code');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<QuestionnaireResultsWithScoringList
							questionnaireCode={questionnaireCode}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
